import * as React from 'react'
import { connect } from 'react-redux'
import { Container, Button, Progress } from 'reactstrap';
import { ApplicationState } from '../../store'
import BlobUtil from '../../utils/blobUtil'
import FaceUtil from '../../utils/faceUtil'
//import { UsersUtil } from '../../utils/dataUtil';
import { Spinner, Col, Row, Form, FormGroup, Label, Input, Alert, Nav, NavItem, NavLink, TabContent, TabPane, CustomInput } from 'reactstrap';
import { UpdateUserProfile as UpdateUserProfileAction, verified as verifiedAction } from '../../store/user/UserActions';
import { IUser } from '../../store/interface'
import classnames from 'classnames';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Modal, ModalBody, ModalHeader, ModalFooter,Badge } from 'reactstrap';
import { fetchUserRequest as getUserAction } from '../../store/user/UserActions';
// @ts-ignore
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
// @ts-ignorenpm 
import countryList from 'react-select-country-list'
// @ts-ignore
import { store } from 'react-notifications-component';
import { authProvider } from '../../utils/authProvider';
import notification from './notification';
import { Link } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
// @ts-ignore
import ReactFlagsSelect from 'react-flags-select';
//import css module
import 'react-flags-select/css/react-flags-select.css';

interface PropsFromState {
    user: IUser
    userInfo : any
}

interface IState {
    [key: string]: any;
    playDuration: number
    faceDetected: boolean
    faceProcessSuccess: boolean
    sendingToServer: boolean
    isIdentical: boolean
    confidence: number
    disableStartButton: boolean
    disableStopButton: boolean
    startButtonClass: string
    faceImages: any[]
    instructionMessage: string,
    progress: number,
    faceDirectionImage: string,
    YawDirection: any,
    notificationContainer : string,
    notificationImage: string,
    notificationId : string,
    UpdateState? : number,
    // membershipCode: string,
    // membershipCategory: string
    isClearable: boolean,
    isSearchable: boolean,
    modalCaptureIC: boolean,
    modalStartCapture: boolean,
    userLoginEmail : string,
    countryList : string,
    positionList : string
}

interface PropsFromDispatch {
    fetchUserRequest : typeof getUserAction
    UpdateUserProfile: typeof UpdateUserProfileAction
    verified: typeof verifiedAction
}

type AllProps = PropsFromState & PropsFromDispatch

class Profile1 extends React.Component<AllProps, IState> {

    user: any;
    blobUtil: BlobUtil;
    faceUtil: FaceUtil;
    //usersUtil: UsersUtil = new UsersUtil();
    interval: any;
    canvasRef: any;
    screenshotRef: any;
    livepreviewRef: any;
    canvasRef2: any;
    screenshotRef2: any;
    livepreviewRef2: any;
    stream: any;
    captureImageList: any[] = [];
    captureImageFileNameList: any[] = [];
    countryOptions: any;

    constructor(props: AllProps) {
        super(props)
        this.state = {
            activeTab: "1",
            setActiveTab: "1",
            playDuration: 0,
            faceDetected: false,
            faceProcessSuccess : false,
            sendingToServer: false,
            isIdentical: false,
            confidence: 0,
            disableStartButton: false,
            disableStopButton: true,
            startButtonClass: "btn btn-primary",
            faceImages: [],
            FullName: this.props.user.fullName,
            IcNo : this.props.user.icNo,
            IcFileName : this.props.user.icFileName,
            ContactNo: this.props.user.contactNo,
            PermanentAdd: this.props.user.permanentAdd,
            PermanentAddState: this.props.user.permanentAddState,
            PermanentAddCity: this.props.user.permanentAddCity,
            PermanentAddPostcode: this.props.user.permanentAddPostcode,
            UpdateState : this.props.user.updateState,
            // membershipCode: this.props.user.membershipCode,
            // membershipCategory: this.props.user.membershipCategory,
            // FullName:this.props.user.fullName,
            // NIRC:this.props.user.NIRC,
            // PersonalContactNumber:this.props.user.PersonalContactNumber,
            // PersonalEmailAddress:this.props.user.PersonalEmailAddress,
            // PersonalAddress:this.props.user.PersonalAddress,
            // CompanyName:this.props.user.CompanyName,
            // Position:this.props.user.Position,
            // CompanyContactNumber:this.props.user.CompanyContactNumber,
            // CompanyAddress:this.props.user.CompanyAddress,
            // SalaryRange:this.props.user.SalaryRange,
            ProfessionalCategory: [],
            AssociationLists: [],
            AdditionalField: [],
            // RegulationBody:this.props.user.RegulationBody,
            // InstitutionAssociationBodyNumber:this.props.user.InstitutionAssociationBodyNumber,
            instructionMessage: "",
            progress: 0,
            faceDirectionImage: '',
            notificationContainer : '',
            notificationImage : '',
            notificationId : '',
            YawDirection: {
                CurrentDirection: 0,
                CaptureSequence: ["Center", "Right", "Left", "Top", "Bottom"],
                LeftBoundaries: -10,
                RightBoundaries: 10,
                Center: {
                    faceDirectionImage: './images/FaceStraight.png',
                    Status: "No Started",
                    Message: "Look straight ahead the camera",
                    faceImages: [],
                    notificationImage: './images/HeadCentre.png',
                    notificationContainer : "top-center"
                },
                Right: {
                    faceDirectionImage: './images/FaceRight.png',
                    Status: "No Started",
                    Message: "Yaw to right side",
                    faceImages: [],
                    notificationImage: './images/HeadYawRight.png',
                    notificationContainer : "top-right"
                },
                Left: {
                    faceDirectionImage: './images/FaceLeft.png',
                    Status: "No Started",
                    Message: "Yaw to left side",
                    faceImages: [],
                    notificationImage: './images/HeadYawLeft.png',
                    notificationContainer : "top-left"
                },
                Top: {
                    faceDirectionImage: './images/FaceLeft.png',
                    Status: "No Started",
                    Message: "Pitch Up",
                    faceImages: [],
                    notificationImage: './images/HeadPitchUp.png',
                    notificationContainer : "top-center"
                },
                Bottom: {
                    faceDirectionImage: './images/FaceRight.png',
                    Status: "No Started",
                    Message: "Pitch Down",
                    faceImages: [],
                    notificationImage: './images/HeadPitchDown.png',
                    notificationContainer : "center"
                }
            },
            //Profession Tab
            SelectedProfessionalCategoryValue: "Select Profession",
            SelectedProfessionalCategoryKey: "",
            ProfessionList: this.props.user.professionList,
            // Accountant_Regulation: "Please Select",
            Selected_Accountancy_Association: "Please Select",
            // CompanySecretary_Regulation: "Please Select",
            Selected_CompanySecretary_Association: "Please Select",
            // TaxAgent_Regulation: "Please Select",
            Selected_TaxAgent_Association: "Please Select",
            // Contractor_Regulation: "Please Select",
            Selected_Contractor_Association: "Please Select",
            // Contractor_Grade: "Please Select",
            // Engineer_Regulation: "Please Select",
            Selected_Engineering_Association: "Please Select",
            ICPicturePath: "",
            ICPicturePath2: "/images/empty-100.png",
            ICPicturePath2FileName: "",
            Selected_IC_Picture: null,
            isClearable: true,
            isSearchable: true,
            lastFailedDirection : this.props.user.lastFailedDirection,
            Position: this.props.user.compPosition,
            CompanyName: this.props.user.compName,
            CompanyRegisterNo: this.props.user.compReg,
            CompanyContactNumber: this.props.user.compContactNo,
            CompanyAddress: this.props.user.compAdd,
            SalaryRange: this.props.user.compSalaryRange,            
            // compPosition: this.state.Position,
            Country: this.props.user.country,
            modalCaptureIC: false,
            modalStartCapture: false,
            userLoginEmail: '',
            isDirty: false,
            countryList : 'Afghanistan, Albania, Algeria, Andorra, Angola, Antigua & Deps, Argentina, Armenia, Australia, Austria, Azerbaijan, Bahamas, Bahrain, Bangladesh, Barbados, Belarus, Belgium, Belize, Benin, Bhutan, Bolivia, Bosnia Herzegovina, Botswana, Brazil, Brunei, Bulgaria, Burkina, Burundi, Cambodia, Cameroon, Canada, Cape Verde, Central African Rep, Chad, Chile, China, Colombia, Comoros, Congo, Congo {Democratic Rep}, Costa Rica, Croatia, Cuba, Cyprus, Czech Republic, Denmark, Djibouti, Dominica, Dominican Republic, East Timor, Ecuador, Egypt, El Salvador, Equatorial Guinea, Eritrea, Estonia, Ethiopia, Fiji, Finland, France, Gabon, Gambia, Georgia, Germany, Ghana, Greece, Grenada, Guatemala, Guinea, Guinea-Bissau, Guyana, Haiti, Honduras, Hungary, Iceland, India, Indonesia, Iran, Iraq, Ireland {Republic}, Israel, Italy, Ivory Coast, Jamaica, Japan, Jordan, Kazakhstan, Kenya, Kiribati, Korea North, Korea South, Kosovo, Kuwait, Kyrgyzstan, Laos, Latvia, Lebanon, Lesotho, Liberia, Libya, Liechtenstein, Lithuania, Luxembourg, Macedonia, Madagascar, Malawi, Malaysia, Maldives, Mali, Malta, Marshall Islands, Mauritania, Mauritius, Mexico, Micronesia, Moldova, Monaco, Mongolia, Montenegro, Morocco, Mozambique, Myanmar, {Burma}, Namibia, Nauru, Nepal, Netherlands, New Zealand, Nicaragua, Niger, Nigeria, Norway, Oman, Pakistan, Palau, Panama, Papua New Guinea, Paraguay, Peru, Philippines, Poland, Portugal, Qatar, Romania, Russian Federation, Rwanda, St Kitts & Nevis, St Lucia, Saint Vincent & the Grenadines, Samoa, San Marino, Sao Tome & Principe, Saudi Arabia, Senegal, Serbia, Seychelles, Sierra Leone, Singapore, Slovakia, Slovenia, Solomon Islands, Somalia, South Africa, South Sudan, Spain, Sri Lanka, Sudan, Suriname, Swaziland, Sweden, Switzerland, Syria, Taiwan, Tajikistan, Tanzania, Thailand, Togo, Tonga, Trinidad & Tobago, Tunisia, Turkey, Turkmenistan, Tuvalu, Uganda, Ukraine, United Arab Emirates, United Kingdom, United States, Uruguay, Uzbekistan, Vanuatu, Vatican City, Venezuela, Vietnam, Yemen, Zambia, Zimbabwe',
            positionList: 'Accounting Analyst,Accounts Executive,Accounts Payable/Receivable Clerk,Architect,Auditor,Bookkeeping,Budget Analyst,Business Analyst,CEO,CFO,Civil Engineer,Civil/Structural Drafter,Clerk,Clerk of Works,Consultant,Contracts Management,Controller,Director,Drafter,Economist,Electrician,Engineer,Finance Manager,Financial,Financial Analyst,Founder,Laboratory Assistant,Management,Marketing,Operation Manager,Personal Assistant,President,Product Management,Project Management,Quality Control,Quality Control/Assurance,R & D Engineer,Secretay/Personal Assistant,Shareholder,Site Supervisor,Supervisor,Support,System Analyst,Taxation,Team Lead,Technical Writer,Technician'
        }
        this.blobUtil = new BlobUtil();
        this.faceUtil = new FaceUtil();
        this.onDismiss = this.onDismiss.bind(this);
        this.setICPicture = this.setICPicture.bind(this);
        this.getProfilePicture = this.getProfilePicture.bind(this);
        this.uploadICPicture = this.uploadICPicture.bind(this);
        this.handleModalCaptureIC = this.handleModalCaptureIC.bind(this);
        this.handleModalStartRecog = this.handleModalStartRecog.bind(this);
        this.bindCaptureEvent = this.bindCaptureEvent.bind(this);
        this.handleCaptureIC = this.handleCaptureIC.bind(this);
        //this.usersUtil.Get().then(this.GetUser.bind(this)).catch(console.log);
        this.countryOptions = countryList().getData();
        this.handleCountryChange = this.handleCountryChange.bind(this);
    }

    
    public async GetEmailAdd():Promise<string>{
        let accountInfo = await authProvider.getAccountInfo();
        let email = accountInfo === null ? '' : accountInfo?.account.idToken.email;
        return email;
    }

    GetUser(data: any) {
        const _user = { ...data, ...this.props.user};
        this.setState({ user:_user  });
        this.faceUtil.setUser(_user);
        this.setState({
            
        })
    }

    handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { target } = event;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const { name } = target;
        if (target) {   
            this.setState({
                [name]: value,
                isDirty: true
            });
        }
    }

    handleSelectOnChange = (target: any, event: any) => {
        if (event.name.toLowerCase() === "position") {
            let _pos: any = [];
            if (event.removedValue !== undefined) {
                const index :number = this.state.Position.indexOf(event.removedValue.value);
                if (index !== -1) {
                    const _pc = [...this.state.Position];
                    _pc.splice(index,1);
                    this.setState({
                        "Position":[ ..._pc],
                        isDirty: true
                    });
                }
            }
            else {
                if (target) {
                    target.forEach((position: any) => {
                        _pos.push(position.value);
                    });
                    this.setState({
                        [event.name]: _pos,
                        isDirty: true
                    });   
                }
            }
        }
        else {      
            if (target) {      
                this.setState({
                    [event.name]: target.value,
                    isDirty: true
                });   
            }   
        }  
    }

    handleModalCaptureIC(){
        this.setState({
            modalCaptureIC : !this.state.modalCaptureIC
        },() => {
            if (this.state.modalCaptureIC === true)
            setTimeout(this.bindCaptureEvent.bind(this), 1000);            
        });
    }
    handleModalStartRecog(){
        this.setState({
            modalStartCapture : !this.state.modalStartCapture
        });
    }

    bindCaptureEvent() {
        const constraints = {
            video: true
        };
        const video: any = document.getElementById('livepreview3');
        navigator.mediaDevices.getUserMedia(constraints).then((_stream) => {
                this.stream = _stream;
                if (video) video.srcObject = this.stream;
                this.setState({ faceDirectionImage: './images/FaceStraight.png' })
            }
        );  
    }

    handleCaptureIC = async (event: any) =>{
        event.preventDefault();
        if (event.target.id === "capture") {
            event.target.innerHTML = "Re-Capture";
            const blob = await this.captureImage("IC", this.livepreviewRef2, this.canvasRef2, this.screenshotRef2);
            var n = new Date();
            let filename = "IC_" + this.replaceAll(n.toISOString(), ":", "") +".png";
            let blobRequestUrl = await this.blobUtil.UploadBlob(filename, blob,"image/png",{resourceType:"ProfilePhoto"});
            //console.log(blobRequestUrl);
            this.setState({
                ICPicturePath2: blobRequestUrl,
                ICPicturePath2FileName: filename
            });
        }
        else {
            this.setState({
                ICPicturePath: this.state.ICPicturePath2,
                icFileName: this.state.ICPicturePath2FileName,
                modalCaptureIC : !this.state.modalCaptureIC,
                isDirty: true
            });
        }
    }

    SetUser(data: any) {
        const _user = { ...data, ...this.props.user };
        this.user = _user;
        //this.setState({ user: _user ,disableStartButton: false});
        this.faceUtil.setUser(_user);
        this.setState({ disableStartButton: false });
    }

    componentDidUpdate(prevProps: AllProps) {
        //console.log({ "prevProps": prevProps, "this.props": this.props });
        /*if( prevProps.user.logged === true ){
            this.SetUser(this.props.user);
        }*/
        
        if ((prevProps.user._etag != this.props.user._etag) || (prevProps.user.updateState != this.props.user.updateState) ){
            this.setState({UpdateState : this.props.user.updateState});
            
            if (this.props.user.updateState === 1){
                if (this.state.disableStartButton == true){
                    // Don't show update success message if do face recognition, else misleading user
                }else{
                    store.addNotification({
                        title: "Info",
                        message: "User profile updated successfully",
                        type: "success",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                        duration: 3000,
                        showIcon: true
                        }
                    });
                    }
            }
            else
            {
                store.addNotification({
                    title: "Alert!",
                    message: 'Failed update user profile: Error : ' + this.props.user?.error??"Failed retriving document",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                      duration: 3000,
                      onScreen: true
                    }
                  });
            }
        }
    }

    async componentDidMount() {
        let email = await this.GetEmailAdd();
        this.setState({userLoginEmail: email});
        
        const { fetchUserRequest: fr, userInfo : userInfo } = this.props
        //if (user === undefined)
        await fr();
       
        if (this.state.ProfessionList.length > 0) {
            let _professionList = this.state.ProfessionList;

            _professionList.forEach((list: any) => {
                this.state.ProfessionalCategory.push(list.profession);
                this.setState({
                    [list.profession + "_Regulation"]: (list.regulators) ? list.regulators : [],
                    [list.profession + "_Association"]: (list.associations) ? list.associations : []
                });

                if (list.regulators) {
                    list.regulators.forEach((_regulatorsObject: any) => {
                        // this.state.AdditionalField = _regulatorsObject.slice();

                        //console.log("----------" + list.profession);

                        if (list.profession === "Contractor") {
                            this.state.AdditionalField.push(list.profession + "_RegistrationNo");
                            this.state.AdditionalField.push(list.profession + "_Grade");
                            this.setState({
                                [list.profession + "_RegistrationNo_Input"]: _regulatorsObject.membershipNo,
                                [list.profession + "_Grade"]: _regulatorsObject.grade
                            })
                        }
                        if (list.profession === "Others") {
                            this.state.AdditionalField.push(list.profession + "_Regulator");
                            this.state.AdditionalField.push(list.profession + "_RegistrationNo");
                            this.state.AdditionalField.push(list.profession + "_Association");
                            this.state.AdditionalField.push(list.profession + "_MembershipNo");
                            this.setState({
                                [list.profession + "_Regulator_Input"]: _regulatorsObject.regulator,
                                [list.profession + "_RegistrationNo_Input"]: _regulatorsObject.registrationNo,
                                [list.profession + "_Association_Input"]: _regulatorsObject.association,
                                [list.profession + "_MembershipNo_Input"]: _regulatorsObject.membershipNo,
                            })
                        }
                        if (list.profession === "Engineering") {
                            this.state.AdditionalField.push(list.profession + "_RegistrationNo" );
                            this.setState({
                                [list.profession + "_RegistrationNo_Input"]: _regulatorsObject.membershipNo,
                            })
                        }
                    });
                }

                if (list.associations.length > 0) {
                    list.associations.forEach((_associationObject: any) => {
                        this.state.AssociationLists.push(list.profession + "_" + _associationObject.name);
                        this.setState({
                            [list.profession + "_" + _associationObject.name + "_Input"]: _associationObject.membershipNo
                        })
                    });
                }
            });
        }

        if (this.props.user.userStatus === "Approved"){
            // this.createNotification('info','User profile is active'); No need create notification
        //}else if (this.props.user.userStatus === "Pending Approval"){
        }else if (this.props.user.userStatus === ""){
            store.addNotification({
                title: "Reminder",
                message: "Please update your user profile before proceed",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                  duration: 3000,
                  onScreen: true
                }
              })
        }else if (this.props.user.userStatus === "Pending Approval"){
            //this.createNotification('warning','Your User profile is pending admin approval.');
            
            store.addNotification({
                title: "Reminder",
                message: "Your User profile is pending admin approval.",
                type: "warning",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                  duration: 3000,
                  onScreen: true
                }
              });
        }

    }

    componentWillUnmount() {
        try {
            if(this.state.activeTab === '4'){
                this.stream.getTracks().forEach(function (track: any) {
                    track.stop();
                });
            }
        } catch (error) {
            console.log(error);
        }
    }

    UpdateUserProfileBtn = async (event: React.MouseEvent<any, MouseEvent>) => {
        event.preventDefault();
        this.props.UpdateUserProfile({
            membershipCode: this.state.membershipCode,
            membershipCategory: this.state.membershipCategory
        });
    }
    UpdateProfessionalInfoBtn = async (event: React.MouseEvent<any, MouseEvent>) => {
        event.preventDefault();
        if (this.professionalCategoryFieldValidation().indexOf(false) < 0) {
            // console.log(this.professionalCategoryFieldValidation());
            //console.log(JSON.stringify(this.constructProfessionList(), null, 4));
            this.props.UpdateUserProfile({
                professionList: this.constructProfessionList()
                // RegulationBody: this.state.RegulationBody,
                // InstitutionAssociationBodyNumber: this.state.InstitutionAssociationBodyNumber
            });
            this.setState({isDirty: false}, ()=> {
                this.toggle('4');
            });
        }
        else {
            alert("All fields are mandatory.");
        }
    }
    UpdatePersonalInfoBtn = async (event: React.MouseEvent<any, MouseEvent>) => {
        
        event.preventDefault();
        if (this.state.FullName && this.state.Country) {

            this.props.UpdateUserProfile({
                emailAdd: this.state.userLoginEmail,
                fullName: this.state.FullName,
                country: this.state.Country
            });
            this.setState({
                isDirty: false
            }, ()=> {
                this.toggle('2');
            });
        }
        else {
            alert("All fields are mandatory.");
        }
    }
    
    UpdateVerificationBtn = async (event: React.MouseEvent<any, MouseEvent>) => {
        
        event.preventDefault();
        if (this.state.IcNo && this.state.ContactNo && this.state.PermanentAdd) {
            
            let userStatus = this.props.user.userStatus;
            if (this.props.user.icNo !== this.state.IcNo){
                userStatus = "Pending Approval";
            }
            
            this.props.UpdateUserProfile({
                emailAdd: this.state.userLoginEmail,
                userStatus: userStatus,
                icNo: this.state.IcNo,
                contactNo: this.state.ContactNo,
                permanentAdd: this.state.PermanentAdd,
                permanentAddState: this.state.PermanentAddState,
                permanentAddCity: this.state.PermanentAddCity,
                permanentAddPostcode: this.state.PermanentAddPostcode,
                icFileName: this.state.icFileName
            });
            this.setState({
                isDirty: false
            }, ()=> {
                this.toggle('5');
            });
        }
        else {
            alert("All fields are mandatory.");
        }
    }
    UpdateCompanyInfoBtn = async (event: React.MouseEvent<any, MouseEvent>) => {
        event.preventDefault();
        if (this.state.CompanyName && this.state.CompanyRegisterNo && (this.state.Position.length > 0) && this.state.CompanyContactNumber && this.state.CompanyAddress && this.state.SalaryRange) {
            this.props.UpdateUserProfile({
                compName: this.state.CompanyName,
                compReg: this.state.CompanyRegisterNo,            
                compPosition: this.state.Position,
                compContactNo: this.state.CompanyContactNumber,
                compAdd: this.state.CompanyAddress,
                compSalaryRange: this.state.SalaryRange,
            });
            this.setState({isDirty: false}, ()=> {
                this.toggle('3');
            });
        }
        else {
            alert("All fields are mandatory.");
        }
    }

    start = async (e: any) => {
        e.preventDefault();

        this.handleModalStartRecog();

        if (this.props.user.userStatus === ""){
            store.addNotification({
                title: "Error",
                message: "Please update your personal info first.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 3000,
                    //onScreen: true
                    showIcon: true,
                }
              });
            return;
        }
        else{
            let instructionMessage = this.state.YawDirection[this.state.YawDirection.CaptureSequence[this.state.YawDirection.CurrentDirection]].Message;
            let faceDirectionImage = this.state.YawDirection[this.state.YawDirection.CaptureSequence[this.state.YawDirection.CurrentDirection]].faceDirectionImage;
            this.faceUtil.setUser(this.props.user);
            this.setState({
                playDuration: 0, sendingToServer: true, disableStartButton: true, disableStopButton: false,
                startButtonClass: "btn btn-primary", faceImages: [],
                instructionMessage: instructionMessage, faceDirectionImage
            }, this.startInternal.bind(this));
        }

    }
    startInternal = async () => {
        let faceIds: any = [];
        let currentDirection = this.state.YawDirection.CurrentDirection;
        const captureSequence = this.state.YawDirection.CaptureSequence;
        this.captureImageList = [];
        this.captureImageFileNameList = [];
        //await this.dummyPause(3000);
        if (this.props.user.personId === undefined || this.props.user.personId === '' ) {
            await this.faceUtil.AddGroup();
            let person: any = await this.faceUtil.AddPerson();
            //await this.usersUtil.Update(person);
            await this.props.UpdateUserProfile({ personId: person.personId, userStatus: "Pending Approval"})
            //this.setState({ user: { ...this.state.user, personId: person.personId } })
            this.faceUtil.setUser({ ...this.props.user, personId: person.personId });
            //await this.AddPersonFace(_captureImageList);
        }else {
            await this.props.UpdateUserProfile({ userStatus: "Pending Approval"})
        }
        /*else{
            this.faceUtil.setUser({ ...this.state.user });
        }
        */
        let isFailed = false;
        for (let captureSequenceIndex = 0; captureSequenceIndex < captureSequence.length; captureSequenceIndex++) { //captureSequenceIndex===0 ? captureSequenceIndex++ : (faceIds.length ===1 ? captureSequenceIndex++:captureSequenceIndex

            // // Restart from Last Failed Attempt
            // if (this.state.lastFailedDirection > 0){
            //     captureSequenceIndex = this.state.lastFailedDirection;
            //     this.setState({
            //         YawDirection: { ...this.state.YawDirection, CurrentDirection: this.state.lastFailedDirection  },
            //         lastFailedDirection : 0 //Reset
            //     });
            // }

            await this.dummyPause(2000);
            this.setState({ progress: this.state.progress + 15 });

            //var faceCaptureNumber = 2; // Number of face to capture for each position
            var faceCaptureNumber = 1; // Number of face to capture for each position
            var faceCaptureCount = 0;
            var faceFailNumber = 5; // Exit if failed for than 5 times
            var faceFailCount = 0; 

            let currentPosition = this.state.YawDirection.CaptureSequence[this.state.YawDirection.CurrentDirection];
            
            do {
                const blob = await this.captureImage("Profile", this.livepreviewRef, this.canvasRef, this.screenshotRef);
                var n = new Date();
                let filename = "Recognize_Source_" + this.replaceAll(n.toISOString(), ":", "") +".png";
                let blobRequestUrl = await this.blobUtil.UploadBlob(filename, blob,"image/png",{resourceType:"ProfilePhoto"});
                //console.log(blobRequestUrl);
                
                faceIds = await this.faceUtil.DetectFace(blobRequestUrl);
                if (faceIds.length === 1) {
                    try {
                        let headPose = faceIds[0].faceAttributes.headPose;
                        console.log(JSON.stringify(headPose));
                        let isValid = false;
                        let errMsg = '';
                        switch(currentPosition){
                            case "Center":
                                //if (headPose.yaw > -10 && headPose.yaw < 10 &&  headPose.pitch > -10 && headPose.pitch < 10){
                                if (headPose.yaw > -10 && headPose.yaw < 10){
                                    isValid = true;
                                }
                                errMsg = 'Look straight to camera';
                                break;
                            case "Right":
                                //console.log("Right : " + headPose.yaw)
                                //if (headPose.yaw < -10) isValid = true;
                                if (headPose.yaw < -5) isValid = true;  // LM 20201920 : User feedback Loosen to not too strict
                                errMsg = 'Yaw to the right more. Current degree:' + Math.abs(headPose.yaw) + '. Should be more than 5. ';
                                break;
                            case "Left":
                                //console.log("Left : " + headPose.yaw)
                                //if (headPose.yaw > 10) isValid = true;
                                if (headPose.yaw > 5) isValid = true; // LM 20201920 : User feedback Loosen to not too strict
                                //errMsg = 'Yaw to the left';
                                errMsg = 'Yaw to the left more. Current degree:' + Math.abs(headPose.yaw) + '. Should be more than 5. ';
                                break;                            
                            case "Top":
                                //console.log("Top : " + headPose.pitch)
                                //if (headPose.pitch > 10) isValid = true;
                                if (headPose.pitch > 5) isValid = true; // LM 20201920 : User feedback Loosen to not too strict
                                errMsg = 'Move your head up a bit. Current degree:' + Math.abs(headPose.pitch) + '. Should be more than 5. ';
                                break;                        
                            case "Bottom":
                                //console.log("Bottom : " + headPose.pitch)
                                //if (headPose.pitch < -10) isValid = true;
                                if (headPose.pitch < -5) isValid = true; // LM 20201920 : User feedback Loosen to not too strict
                                errMsg = 'Move your head down a bit. Current degree:' + Math.abs(headPose.pitch) + '. Should be more than 5. ';
                                break;
                        }
                        if (isValid){
                            await this.faceUtil.AddPersonFace(blobRequestUrl);
                            faceCaptureCount ++;
                            faceFailCount = 0; // Reset once success
                            this.captureImageList.push({ src: blobRequestUrl, blob: blob, faceCaptureCount, filename : filename });

                            if (faceCaptureCount === 2){ // Take second picture to show enough
                                this.captureImageFileNameList.push(filename);
                            }
                            this.setState({ faceDetected: true, faceProcessSuccess : true, instructionMessage: "Processing " + currentPosition +  " (" + faceCaptureCount +  ")..." });
                        }else{
                            faceFailCount ++;
                            this.setState({ faceDetected: true, faceProcessSuccess : false, instructionMessage: errMsg  +". Retrying " + faceFailCount + "..."});
                        }
                    } catch (error) {
                        //console.log(error);
                        //alert(error);
                        faceFailCount ++;
                        this.setState({ faceDetected: true, faceProcessSuccess : false, instructionMessage: error.message });
                    }
                }
                else if (faceIds.length > 1) {
                    //Todo: Delete the Blob
                    faceFailCount ++;
                    this.setState({ faceDetected: true, faceProcessSuccess : false, instructionMessage: "Only you can stay in front of the camera. Retrying " + faceFailCount + "..."});
                    //console.log("Multi Faces detect");
                }
                else {
                    //Todo: Delete the Blob
                    faceFailCount ++;
                    this.setState({ faceDetected: false, faceProcessSuccess : false, instructionMessage: "No face detected. Please stay in camera. Retrying " + faceFailCount + "..."});
                }
                await this.dummyPause(1000);
            } while(faceCaptureCount < faceCaptureNumber && faceFailCount < faceFailNumber);

            if (faceFailCount >= faceFailNumber){
                store.removeNotification(this.state.notificationId); // Remove current notification
                
                // Record last failed direction, direct restart from there
                this.props.UpdateUserProfile({
                    lastFailedDirection: this.state.YawDirection.CurrentDirection,
                });

                this.setState({
                    progress: 100,
                    YawDirection: { ...this.state.YawDirection, CurrentDirection: 0 },
                    disableStartButton: false, disableStopButton: true
                });
                isFailed = true;


                store.addNotification({
                    title: "Alert!",
                    message: 'Please try again.',
                    type: "danger",
                    insert: "top",
                    container: "center",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                      duration: 3000,
                      //onScreen: true
                    }
                  });

                break;
            }

            currentDirection++;
            let _Message: string = "Face Update Done";
            let _faceDirectionImage: string = "";
            let _notificationContainer: string = "";
            let _notificationImage : string = "";
            if (currentDirection < this.state.YawDirection
                .CaptureSequence.length) {
                let { Message, faceDirectionImage, notificationContainer, notificationImage } = this.state
                    .YawDirection[
                        this.state.YawDirection.CaptureSequence[currentDirection]
                    ];
                _Message = Message;
                _faceDirectionImage = faceDirectionImage;
                _notificationContainer = notificationContainer;
                _notificationImage = notificationImage;
            }

            this.setState({
                instructionMessage: _Message,
                YawDirection: { ...this.state.YawDirection, CurrentDirection: currentDirection },
                faceDirectionImage: _faceDirectionImage
            });
        }
      
        //await this.ProcessImage(this.captureImageList);
        if (!isFailed){
            // Update list of file name
            await this.props.UpdateUserProfile({ 
                faceImageList: this.captureImageFileNameList, 
                faceImageLastUpdated : new Date()
            });

            this.setState({ progress: 80 });
            await this.faceUtil.Train();
            this.setState({ progress: 100 });
            await this.dummyPause(1000);
            let firstFaceDirectionImage = this.state.YawDirection[this.state.YawDirection.CaptureSequence[0]].faceDirectionImage;

            store.addNotification({
                title: "Info",
                message: "Congratulation! Face Recognition processed completed! Enjoy watching your courses now!",
                type: "success",
                insert: "top",
                container: "top-center",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                duration: 3000,
                showIcon: true
                }
            });

            this.setState({
                instructionMessage: "Faces is updated", YawDirection: { ...this.state.YawDirection, CurrentDirection: 0 },
                faceDirectionImage: firstFaceDirectionImage,
                disableStartButton: false, disableStopButton: true
            });
        }
    }

    replaceAll(target: string, search: string, replacement: string) {
        return target.replace(new RegExp(search, 'g'), replacement);
    }

    dummyPause(interval: number) {
        return new Promise(function (resolve, reject) {
            setTimeout(() => { resolve(); }, interval);
        });
    }

    stop = async (e: any) => {
        e.preventDefault();
        this.setState({ disableStartButton: false, disableStopButton: true });

        //this.stopInternal();
    }

    captureImage(source:string, video: any, canvas: any, img: any) {
        return new Promise(function (resolve, reject) {
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            
            var ctx = canvas.getContext('2d');
            //ctx.scale(-1, 1);
            ctx.drawImage(video, 0, 0);
            
            // Add Timestamp
            if (source == "Profile"){ // Add timestamp only if from Face recognitions
                var timestamp = new Date();
                // var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
                // let timestampFormatted = timestamp.toLocaleDateString("en-US", options);
                var options = { year: 'numeric', month: 'short', day: 'numeric', hour: "2-digit", minute: "2-digit" } as const;
                let timestampFormatted = timestamp.toLocaleTimeString("en-US", options);
                let font ="11px Arial"
                ctx.font = font;                        
                // var gradient = ctx.createLinearGradient(0, 0, 400, 0);
                // gradient.addColorStop("0","magenta");
                // gradient.addColorStop("0.5", "blue");
                // gradient.addColorStop("1.0", "red");
                // Fill with gradient
                //ctx.fillStyle = gradient;
                ctx.textBaseline = 'top';
                ctx.fillStyle = '#3a3a3c';
                /// get width of text
                var width = ctx.measureText(timestampFormatted).width;

                /// draw background rect assuming height of font
                ctx.fillRect(6, 6, width + 5, parseInt(font, 10) + 5);

                // text color
                ctx.fillStyle = '#fff';
                                
                ctx.fillText(timestampFormatted, 8, 8);
            }

            img.src = canvas.toDataURL('image/png');

            canvas.toBlob(
                function (blob: any) {
                    //setTimeout(() => { resolve(blob); }, 5000);
                    resolve(blob);
                }
            );
        });
    }

    onDismiss(){
       this.setState({ UpdateState : 0 });
    }

    async setICPicture(event: any) {
        event.preventDefault();
        const { files } = event.target;

        var n = new Date();
        let filename = "IC_" + this.replaceAll(n.toISOString(), ":", "") + "." + files[0].type.split('/')[1];
        let blobRequestUrl = await this.blobUtil.UploadBlob(filename, files[0],"image/png",{resourceType:"ProfilePhoto"});
        //console.log(blobRequestUrl);

        this.setState({
            ICPicturePath: blobRequestUrl,
            icFileName: filename,
            isDirty: true
        }, () => {
            this.props.UpdateUserProfile({
                userStatus: "Pending Approval",
                // icFileName: filename
            });
        });
        
        // _self.setState({
        //     Selected_IC_Picture: files[0],
        // });
    }

    async getProfilePicture() {
        let blobRequestUrl = await this.blobUtil.GetBlob(this.state.IcFileName);
        //console.log(blobRequestUrl);
        this.setState({
            ICPicturePath: blobRequestUrl
        });
    }

    async uploadICPicture() {
        let file = this.state.Selected_IC_Picture;
        if (file !== undefined && file !== null) {
            var n = new Date();
            let filename = "IC_" + this.replaceAll(n.toISOString(), ":", "") + "." + file.type.split('/')[1];
            let blobRequestUrl = await this.blobUtil.UploadBlob(filename, file,"image/png",{resourceType:"ProfilePhoto"});
            //console.log(blobRequestUrl);
    
            this.setState({
                ICPicturePath: blobRequestUrl
            }, () => {
                this.props.UpdateUserProfile({
                    userStatus: "Pending Approval",
                    icFileName: filename
                });
            });
        }
        else if (this.state.ICPicturePath2FileName !== "") {
            this.props.UpdateUserProfile({
                userStatus: "Pending Approval",
                icFileName: this.state.ICPicturePath2FileName
            });
        }
        else {
            alert("Please choose at least one file!");
        }
    }

    private toggle = (tab: any) => {
        if (this.state.isDirty) {
            alert("You have unsaved changes, please update before proceed.");
        }
        if (this.state.activeTab !== tab && !this.state.isDirty){
            this.setState({ activeTab: tab });
            
            if(tab === "5"){
                const constraints = {
                    video: true
                };
                const video: any = document.getElementById('livepreview2');
                navigator.mediaDevices.getUserMedia(constraints).then((_stream) => {
                    this.stream = _stream;
                    video.srcObject = this.stream;
                    this.setState({ faceDirectionImage: './images/FaceStraight.png' })
                }
                );
            }
            else if(this.state.activeTab === '5')
            {
                try {
                    this.stream.getTracks().forEach(function (track: any) {
                        track.stop();
                    });
                } catch (error) {
                    console.log(error);
                }
            }        
        }
    }
    renderIdentity() {
        return (
            <div className="mt-3 mb-3" >
                <div className="row" >
                    <h5>AI Face Recognition</h5>
                </div>
                <div className="row" >
                    {/* <div className="col-md-6">
                        <div className="d-flex justify-content-center">
                            <img src={this.state.faceDirectionImage} alt="" style={{ width: "250px" }} />
                        </div>
                    </div> */}
                    <div className="col-md-12">
                        <div className="d-flex justify-content-center">
                            <video ref={(input) => { this.livepreviewRef = input; }} autoPlay={true} width="500px" style={{ padding: "5px" }} className="videoMirror" id="livepreview2"></video>
                            <canvas ref={(input) => { this.canvasRef = input; }} style={{ display: "none" }}></canvas>
                            <img ref={(input) => { this.screenshotRef = input; }} style={{ display: "none" }} id="screenshot" alt="" />
                        </div>
                    </div>
                </div>
                {/* <div className="d-flex justify-content-center">
                    {
                        this.state.instructionMessage && (
                            <Alert color="danger" >{this.state.instructionMessage}</Alert>
                        )
                    }
                </div> */}
                <div className="d-flex justify-content-left" hidden={this.state.disableStartButton}>
                    {/* <Progressbar start={this.state.disableStartButton} progress={this.state.progress} /> */}
                </div>
                {/* <div className="d-flex justify-content-center">
                    <Alert color="success" isOpen={this.state.disableStartButton}>
                        Face Detected: {this.state.faceDetected ? "Yes" : <span className="text-danger">No</span>}
                    </Alert>
                </div> */}
                {/* {
                    JSON.stringify(this.props.user)
                } */}
                <div className="row bg-secondary clearfix p-2">
                    <div className="col-md-3">
                        <input type="button" className={this.state.startButtonClass + " float-left mr-1"} id="StartRecognition" value="Start Face Recognition" disabled={this.state.disableStartButton} onClick={this.handleModalStartRecog} />
                    </div>
                    <div className="col-md-6" style={{textAlign: "center"}}>
                        {/* <Alert color="light" isOpen={this.state.disableStartButton}>
                            {this.state.instructionMessage}
                        </Alert> */}
                        {/* <Alert color="success" isOpen={this.state.disableStartButton}>
                            Face Detected: {this.state.faceDetected ? "Yes" : <span className="text-danger">No</span>}
                        </Alert> */}
                        {/* <Alert color="light" isOpen={this.state.disableStartButton}>
                            {this.state.instructionMessage}
                        </Alert>  */}
                        <Link className="btn btn-success" to="/mycourses"><i className="fas fa-play-circle mr-1"></i>&nbsp;Back to My Courses</Link>
                    </div>
                    <div className="col-md-3">
                        <input type="button" className="btn btn-danger float-right" id="StopRecognition" value="Stop analyze" disabled={this.state.disableStopButton} onClick={this.stop.bind(this)} />
                    </div>
                </div>
                {/* <div className="row" >
                    <div className="col-md-12">
                        <div className="d-flex justify-content-left">
                            <h4>Hints</h4>
                            <ul>
                                <li>Make sure camera is on and allowed for UltimatesPro Website</li>
                                <li>Make sure you stay in bright room</li>
                                <li>Make sure your face is in the camera canvas</li>
                                <li>Stay away in 1.5ft distance to camera</li>
                                <li>Stay straight during capturing session</li>
                            </ul>
                        </div>
                    </div>
                </div> */}
                <Modal size="lg" isOpen={this.state.modalStartCapture} unmountOnClose={true}>
                    <ModalHeader toggle={this.handleModalStartRecog}>Hints</ModalHeader>
                    <ModalBody>
                        <Col sm={12}>
                            <h5>Before you start, here are some hints:-</h5>
                            <ul>
                                <li>Make sure camera is on and allowed for UltimatesPro Website</li>
                                <li>Make sure you stay in bright room</li>
                                <li>Make sure your face is in the camera canvas</li>
                                {/* <li>Stay away in 1.5ft distance to camera</li> */}
                                <li>Stay straight during capturing session</li>
                                <li>Follow instructions to move your head to center, yaw to right, yaw to left, pitch up and pitch down.</li>
                            </ul>
                        </Col>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="warning" onClick={this.start.bind(this)} id="startRecog" >Ok I am ready. Start Now!</Button>
                        <Button color="secondary" onClick={this.handleModalStartRecog} id="cancelRecog" >Cancel</Button>
                    </ModalFooter>
                </Modal>

            </div>
        );
    }
    handleSelectedOption = (optionList: any, name: string) => {
        let index = optionList.map(function(e: any) { 
            return e.value; 
        }).indexOf(name);

        if (index !== -1) {
            return optionList[index];
        }
    }

    handleMultiSelectedOption = (optionList: any, name: any) => {
        let arr: any = [];
        if (name){
            name.forEach((element:any) => {
                let index = optionList.map(function(e: any) { 
                    return e.value; 
                }).indexOf(element);
        
                if (index !== -1) {
                    arr.push(optionList[index]);
                }
                else {
                    optionList.push({value: element, label: element});
                    let index1 = optionList.map(function(e: any) { 
                        return e.value; 
                    }).indexOf(element);
                    arr.push(optionList[index1]);
                }
            });
        }

        return arr;
    }
    handleCountryChange(countryCode:any){
        this.setState({Country: countryCode });
    }

    renderPersonal(){
        // const countryOptions = [
        //     { value: 'Malaysia', label: 'Malaysia' },
        //     { value: 'Singapore', label: 'Singapore' },
        //     { value: 'United States', label: 'United States' },
        //     { value: 'Ireland', label: 'Ireland' },
        // ];
        //const _countryOptions = this.countryOptions;
        const _countryOptions = countryList().getData();
                
        const handleMultiSelectedOption = (optionList: any, name: any) => {
            let arr: any = [];
            if (name && optionList){
                name.forEach((element:any) => {
                    let index = optionList.map(function(e: any) { 
                        return e.label; 
                    }).indexOf(element);
            
                    if (index !== -1) {
                        arr.push(optionList[index]);
                    }
                });
            }

            return arr;
        }
        const countryHandler = (value : any) => {
            this.setState({ Country : value});
          }
        
        return (

            <Form className="mt-3 mb-3" onSubmit={(event: React.MouseEvent<any, MouseEvent>) => this.UpdatePersonalInfoBtn(event)}>
                <FormGroup row={true}>
                    <Label for="EmailAdd" sm={2}>Email Address</Label >
                    <Col sm={10}>
                        <Input type="email" name="EmailAdd" 
                            value={this.props.user?.emailAdd == ""? this.state.userLoginEmail : this.props.user?.emailAdd}
                            readOnly = {true}
                        />
                    </Col>
                </FormGroup>        
                <FormGroup row={true}>
                    <Label for="FullName" sm={2}>Full Name as I.D.</Label >
                    <Col sm={10}>
                        <Input type="text" name="FullName" 
                            value={this.state.FullName}
                            onChange={this.handleChange.bind(this)}
                        />
                    </Col>
                </FormGroup>       
                <FormGroup row={true}>
                    <Label for="Country" sm={2}>Country / Region</Label >
                    <Col sm={10}>
                        <ReactFlagsSelect 
                            name="Country"
                            searchable={true}
                            searchPlaceholder="Search for a country"
                            customLabels={{"TW": "Taiwan"}}
                            defaultCountry={this.state.Country} 
                            ref="userCountryFlag"
                            onSelect={this.handleCountryChange}
                            />
                    </Col>
                </FormGroup>
                <FormGroup row={true}>
                </FormGroup>
                <FormGroup row={true}>
                    <Col sm={12}>
                        <Button color="primary" className="float-right">Update Personal Info</Button>
                    </Col>
                </FormGroup>
            </Form>

        );
    }

    renderVerification(){
        // const countryOptions = [
        //     { value: 'Malaysia', label: 'Malaysia' },
        //     { value: 'Singapore', label: 'Singapore' },
        //     { value: 'United States', label: 'United States' },
        //     { value: 'Ireland', label: 'Ireland' },
        // ];
        const _countryOptions = this.countryOptions;
        
        return (

            <Form className="mt-3 mb-3" onSubmit={(event: React.MouseEvent<any, MouseEvent>) => this.UpdateVerificationBtn(event)}>
                {/* <h1>{this.state.UpdateState}</h1>  */}     
                <FormGroup row={true}>
                    <Label for="Status" sm={2}>Status</Label >
                    <Col sm={10}>
                    {this.props.user?.userStatus == "Approved" ? (
                            <div><Badge color="success" style={{fontSize:"large"}}>{this.props.user?.userStatus}</Badge><span> (Eligible for Verified Track)</span></div>
                        ):(
                            <div><Badge color="danger" style={{fontSize:"large"}}>Pending Approval</Badge><span> (Ineligible for Verified Track)</span></div>
                        ) 
                    }
                    </Col>
                </FormGroup> 
                <FormGroup row={true}>
                    <Label for="IcNo" sm={2}>I.D. Number</Label >
                    <Col sm={10}>
                        <Input type="text" name="IcNo" 
                            value={this.state.IcNo}
                            onChange={this.handleChange.bind(this)}
                        />
                    </Col>
                </FormGroup>
                <FormGroup row={true}>
                    <Label for="ContactNo" sm={2}>Contact Number</Label >
                    <Col sm={10}>
                        {/* <Input type="text" name="ContactNo" 
                            value={this.state.ContactNo}
                            onChange={this.handleChange.bind(this)}
                        /> */}
                        <PhoneInput
                            country={'my'} 
                            placeholder="+60 12-123 4567"
                            enableSearch = {true}
                            onlyCountries={['my','sg','kh','vn','in','id','th','ph','bn']}
                            masks={{my: '..-..........', sg: '..-..........', kh: '..-..........'}}
                            value={this.state.ContactNo} 
                            onChange={phone => this.setState({ ContactNo : phone })}
                        />
                    </Col>
                </FormGroup>
                <FormGroup row={true}>
                    <Label for="PermanentAdd" sm={2}>Home Address</Label >
                    <Col sm={10}>
                        <Input type="textarea" name="PermanentAdd" id="PermanentAdd"
                            value={this.state.PermanentAdd} rows={3} style={{width: "100%"}}
                            onChange={this.handleChange.bind(this)}
                        />
                    </Col>
                </FormGroup>
                <FormGroup row={true}>
                    <Label for="PermanentAddPostcode" sm={2}>Postcode</Label >
                    <Col sm={2}>
                        <Input type="text" name="PermanentAddPostcode" id="PermanentAddPostcode"
                            value={this.state.PermanentAddPostcode} style={{width: "100%"}}
                            onChange={this.handleChange.bind(this)}
                        />
                    </Col>
                    <Label for="PermanentAddCity" sm={1}>City</Label >
                    <Col sm={3}>
                        <Input type="text" name="PermanentAddCity" id="PermanentAddCity"
                            value={this.state.PermanentAddCity} style={{width: "100%"}}
                            onChange={this.handleChange.bind(this)}
                        />
                    </Col>
                </FormGroup>
                <FormGroup row={true}>
                    <Label for="PermanentAddState" sm={2}>State</Label >
                    <Col sm={3}>
                        <Input type="text" name="PermanentAddState" id="PermanentAddState"
                            value={this.state.PermanentAddState} style={{width: "100%"}}
                            onChange={this.handleChange.bind(this)}
                        />
                    </Col>
                </FormGroup>
                <FormGroup row={true}>
                    <Col sm={2}><Label>Upload / Capture I.D.</Label ></Col>
                    <Col sm={4} style={{display: "flex", paddingRight: "0"}}>                    
                        <CustomInput type="file" id="img" name="img" accept="image/png, image/jpeg, image/jpg" onChange={this.setICPicture} />
                    </Col>
                    <Col sm={6} style={{display: "flex", paddingLeft: "0"}}>
                        {/* <Button color="secondary" onClick={this.uploadICPicture} >Upload</Button> */}
                        <Label sm={1} style={{textAlign: "center"}}>Or</Label>

                        <Button color="secondary" style={{width: "280px"}} onClick={this.handleModalCaptureIC}><i className="fas fa-camera mr-1"></i>
                        &nbsp;Capture From Camera</Button>
                        
                    </Col>
                </FormGroup>
                <FormGroup row={true}>
                    <Col sm={2}></Col>
                    <Col sm={10} style={{textAlign:"center"}}>
                        <span style={{color:"red", fontWeight:"bold"}}>Any form of ID Card with name and photo can be use. <br/>It must be captured in a clear image. This is to ensure that our system can verify the name and face registered easily.</span>
                    </Col>
                </FormGroup>
                <FormGroup row={true}>
                    <Label for="img" sm={2}></Label >
                    <Col sm={5}>
                        <img ref={this.getProfilePicture} src={this.state.ICPicturePath} hidden={(this.state.ICPicturePath === "") ? true : false} alt="" width={400} />
                    </Col>
                    <Col sm={5}>
                        <img src="./images/ic-sample.png" alt="Sample I.D. Photo" width={400} />
                    </Col>
                </FormGroup>
                <Modal size="xl" isOpen={this.state.modalCaptureIC} unmountOnClose={true}>
                    <ModalHeader toggle={this.handleModalCaptureIC}>Capture From Camera</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col sm={6}>
                                <br />
                                <video ref={(input) => { this.livepreviewRef2 = input; }} autoPlay={true} width="400px" className="videoMirror" id="livepreview3"></video>
                                <canvas ref={(input) => { this.canvasRef2 = input; }} style={{ display: "none" }}></canvas>
                            </Col>
                            <Col sm={6}>
                                Preview: <br />
                                <img ref={(input) => { this.screenshotRef2 = input; }} id="screenshot" alt="" src={this.state.ICPicturePath2} width="400px" style={{transform: "scaleX(-1)"}} />
                                {/* <img ref={(input) => { this.screenshotRef2 = input; }} id="screenshot" alt="" src={this.state.ICPicturePath2} width="400px"  /> */}
                                
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.handleCaptureIC} id="capture" >Capture</Button>
                        <Button color="secondary" onClick={this.handleCaptureIC} id="confirm" >Confirm</Button>
                    </ModalFooter>
                </Modal>
                {/* <div className="row">
                    <div className="col-12">
                        <Button color="primary" className=" float-right"  >Update</Button>
                    </div>
                </div> */}
                
                <FormGroup row={true}>
                    <Col sm={12}>
                        <Button color="primary" className="float-right">Update Personal Info</Button>
                    </Col>
                </FormGroup>
            </Form>

        );
    }

    onProfessionalCategoryBtnClick = (selected:string) => {
        const index :number = this.state.ProfessionalCategory.indexOf(selected);
        if (index < 0) {
          this.setState({"ProfessionalCategory":[ ...this.state.ProfessionalCategory, selected]});//.push(selected);
        } else {
            const _pc = [...this.state.ProfessionalCategory];
            _pc.splice(index,1);
            this.setState({"ProfessionalCategory":[ ..._pc]});
        } 
    }
    
    handleOnProfessionalCategory = (key: string, value: string) => {
        this.setState({ SelectedProfessionalCategoryKey: key, SelectedProfessionalCategoryValue: value });
    }

    handleOnRemoveProfessionalCategory = (value: string) => {
        if (window.confirm("Are you sure want to remove this category?")) {
            const index :number = this.state.ProfessionalCategory.indexOf(value);
            if (index !== -1) {
                const _pc = [...this.state.ProfessionalCategory];
                _pc.splice(index,1);
                this.setState({"ProfessionalCategory":[ ..._pc]});
            } 
        }
    }

    handleOnRemoveAssociation = (associationName: string) => {
        if (window.confirm("Are you sure want to remove this association?")) {
            const index :number = this.state.AssociationLists.indexOf(associationName);
            if (index !== -1) {
                const _al = [...this.state.AssociationLists];
                _al.splice(index,1);
                this.setState({"AssociationLists":[ ..._al]});
            } 
        }
    }

    handleOnProfessionalForm = () => {
        let selectedProfession = this.state.SelectedProfessionalCategoryKey;

        const index :number = this.state.ProfessionalCategory.indexOf(selectedProfession);
        if (index < 0) {
          this.setState({"ProfessionalCategory":[ ...this.state.ProfessionalCategory, selectedProfession]});
        }
        else {
            alert("This category has been added.");
        }
    }

    handleOnRegulation = (category: string, value: string) => {
        this.setState({ 
            [category + "_Regulation"]: [{
                "name": value
            }]
        }, () => {
            if (category === "Contractor") {
                const index :number = this.state.AdditionalField.indexOf(category + "_RegistrationNo");
                if (index < 0) {
                    this.setState({
                        "AdditionalField":[ ...this.state.AdditionalField, category + "_RegistrationNo"]
                    },() => {
                        const index2 :number = this.state.AdditionalField.indexOf(category + "_Grade");
                        if (index2 < 0) {
                          this.setState({"AdditionalField":[ ...this.state.AdditionalField, category + "_Grade"]});
                        }
                    });
                }
            }
            if (category === "Engineering") {
                const index :number = this.state.AdditionalField.indexOf(category + "_RegistrationNo");
                if (index < 0) {
                  this.setState({"AdditionalField":[ ...this.state.AdditionalField, category + "_RegistrationNo"]});
                }
            }
        });
    }

    handleOnAssociation = (category: string, value: string) => {
        this.setState({ ["Selected_" + category + "_Association"] : value });
    }

    handleOnContractorGrade = (category: string, value: string) => {
        this.setState({ [category + "_Grade"] : value });
    }

    handleOnAssociationInputField = (category: string, stateName: string) => {
        let selectedAssociation = this.state[stateName].match(/\([a-zA-Z]+\)/g)[0].replace("(","").replace(")","");

        const index :number = this.state.AssociationLists.indexOf(category + "_" + selectedAssociation);
        if (index < 0) {
            this.setState({
              "AssociationLists": [ ...this.state.AssociationLists, category + "_" + selectedAssociation],
              ["Selected_" + category + "_Association"]: "Please Select"
            });
        }
        else {
            alert("This association has been added.");
        } 
    }

    private constructProfessionList = (): any => {
        let list : any = [];

        this.state.ProfessionalCategory.forEach((_category: string) => {
            list.push({
                profession: _category,
                regulators: this.contructCategoryRegulator(_category),
                associations: this.contructCategoryAssociation(_category)
            });
        });

        return list;
    }

    private contructCategoryRegulator = (category: string): any => {
        let regulator : any = [];

        if (category === "Contractor") {
            regulator.push({ 
                name: this.state[category + "_Regulation"][0].name,
                grade: this.state[category + "_Grade"],
                membershipNo: this.state[category + "_RegistrationNo_Input"]
            });
        }
        else if (category === "Others") {
            regulator.push({ 
                regulator: this.state[category + "_Regulator_Input"],
                registrationNo: this.state[category + "_RegistrationNo_Input"],
                association: this.state[category + "_Association_Input"],
                membershipNo: this.state[category + "_MembershipNo_Input"]
            });
        }
        else if (category === "Engineering") {
            regulator.push({ 
                name: this.state[category + "_Regulation"][0].name,
                membershipNo: this.state[category + "_RegistrationNo_Input"]
            });
        }
        else {
            regulator = this.state[category + "_Regulation"].slice();
        }

        return regulator;
    }

    private contructCategoryAssociation = (category: string): any => {
        let associations : any = [];

        let matchAssociations = this.state.AssociationLists.filter(function (_cat: string) {
            return _cat.startsWith(category);
        });

        if (matchAssociations.length > 0) {
            matchAssociations.forEach((_association: string) => {
                associations.push({ 
                    name: _association.split("_")[1],
                    membershipNo: this.state[_association + "_Input"]
                });
            });
        }

        return associations;
    }

    private professionalCategoryFieldValidation = (): any => {
        let arr: any = [];

        this.state.ProfessionalCategory.forEach((category: string) => {
            if (category === "Contractor") {
                if (!this.state[category + "_Regulation"] || !this.state[category + "_Grade"] || !this.state[category + "_RegistrationNo_Input"])
                    arr.push(false);
            }
            else if (category === "Others") {
                if (!this.state[category + "_RegistrationNo_Input"] || !this.state[category + "_Association_Input"] || !this.state[category + "_MembershipNo_Input"])
                    arr.push(false);
            }
            else if (category === "Engineering") {
                if (!this.state[category + "_Regulation"] || !this.state[category + "_RegistrationNo_Input"])
                    arr.push(false);
            }
            else {
                if (!this.state[category + "_Regulation"])
                    arr.push(false);
            }

            let matchAssociations = this.state.AssociationLists.filter((_cat: string) => {
                return _cat.startsWith(category);
            });
    
            if (matchAssociations.length > 0) {
                matchAssociations.forEach((_association: string) => {
                    if (!this.state[_association + "_Input"])
                        arr.push(false);
                });
            }
        });

        return arr;
    }

    renderProfessional(){
        return (

            <Form className="mt-3 mb-3" onSubmit={(event: React.MouseEvent<any, MouseEvent>) => this.UpdateProfessionalInfoBtn(event)}> 
                <FormGroup row={true}>
                    <Label for="ProfessionalCategory" className="col-sm-3 col-form-label">Professional Category</Label >
                    {/* <Col sm={10}>
                        <ButtonGroup className="professioanlCategory">
                            <Button color="secondary" className="mr-2" onClick={() => this.onProfessionalCategoryBtnClick("Accountant")} active={this.state.ProfessionalCategory.includes("Accountant")}>Accountant</Button>
                            <Button color="secondary" className="mr-2" onClick={() => this.onProfessionalCategoryBtnClick("Contractors")} active={this.state.ProfessionalCategory.includes("Contractors")}>Contractors</Button>
                            <Button color="secondary" className="mr-2" onClick={() => this.onProfessionalCategoryBtnClick("Tax Agent")} active={this.state.ProfessionalCategory.includes("Tax Agent")}>Tax Agent</Button>
                            <Button color="secondary" className="mr-2" onClick={() => this.onProfessionalCategoryBtnClick("Company Secretary")} active={this.state.ProfessionalCategory.includes("Company Secretary")}>Company Secretary</Button>
                            <Button color="secondary" className="mr-2" onClick={() => this.onProfessionalCategoryBtnClick("Engineers")} active={this.state.ProfessionalCategory.includes("Engineers")}>Engineers</Button>
                        </ButtonGroup>
                        <br/>
                        <p>You have selected: {JSON.stringify(this.state.ProfessionalCategory)}</p>
                    
                    </Col> */}

                    <UncontrolledDropdown>
                        <DropdownToggle caret>
                            {this.state.SelectedProfessionalCategoryValue}
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem onClick={() => this.handleOnProfessionalCategory("Accountancy", "Accountancy")}>Accountancy</DropdownItem>
                            <DropdownItem onClick={() => this.handleOnProfessionalCategory("CompanySecretary", "Company Secretary")}>Company Secretary</DropdownItem>
                            <DropdownItem onClick={() => this.handleOnProfessionalCategory("TaxAgent", "Tax Agent")}>Tax Agent</DropdownItem>
                            <DropdownItem onClick={() => this.handleOnProfessionalCategory("Contractor", "Contractor")}>Contractor</DropdownItem>
                            <DropdownItem onClick={() => this.handleOnProfessionalCategory("Others", "Others")}>Others</DropdownItem>
                            {/* <DropdownItem onClick={() => this.handleOnProfessionalCategory("Engineering", "Engineering")}>Engineering</DropdownItem> */}
                        </DropdownMenu>
                    </UncontrolledDropdown>
                    &nbsp;
                    <Button color="primary" onClick={() => this.handleOnProfessionalForm()} disabled={ this.state.SelectedProfessionalCategoryValue === "Select Profession" ? true : false }>Add New</Button>
                </FormGroup>

                <FormGroup hidden={ this.state.ProfessionalCategory.indexOf("Accountancy") < 0 ? true : false } id="Accountancy_Form" style={{ backgroundColor: "lightgrey" }}>
                    <Label for="Accountancy" className="col-sm-11 col-form-label"><b>Accountancy</b></Label >
                    <Button close onClick={() => this.handleOnRemoveProfessionalCategory("Accountancy")} style={{padding: "7px 15px"}} title="Remove"></Button>
                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }}>
                        <Label for="RegulationBody" sm={4}>Regulator</Label >
                        <UncontrolledDropdown>
                            <DropdownToggle caret>{(this.state.Accountancy_Regulation !== undefined && this.state.Accountancy_Regulation.length > 0) ? this.state.Accountancy_Regulation[0].name : "Please Select" }</DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem onClick={() => this.handleOnRegulation("Accountancy", "Akauntan Negara Malaysia (ANM)")}>Akauntan Negara Malaysia (ANM)</DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </FormGroup>
                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }}>
                        <Label for="AssociationBody" sm={4}>Association/Institution</Label >
                        <UncontrolledDropdown>
                            <DropdownToggle caret>{ this.state.Selected_Accountancy_Association }</DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem onClick={() => this.handleOnAssociation("Accountancy", "Malaysia Institute of Accountants (MIA)")}>Malaysia Institute of Accountants (MIA)​</DropdownItem>
                                <DropdownItem onClick={() => this.handleOnAssociation("Accountancy", "Malaysia Institute of Certified Public Accounts (MICPA)​")}>Malaysia Institute of Certified Public Accounts (MICPA)​</DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                        &nbsp;
                        <Button color="primary" onClick={() => this.handleOnAssociationInputField("Accountancy", "Selected_Accountancy_Association")} disabled={ this.state.Selected_Accountancy_Association === "Please Select" ? true : false }>Add New</Button>
                    </FormGroup>

                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }} hidden={ this.state.AssociationLists.indexOf("Accountancy_MIA") < 0 ? true : false } >
                        <Label for="Accountancy_MIA_Input" sm={4}>(MIA) Membership Number</Label >
                        <div className="col-sm-4" style={{ padding: "0 10px 0 0" }}>
                            <Input type="text" name="Accountancy_MIA_Input" value={this.state["Accountancy_MIA_Input"]} onChange={this.handleChange.bind(this)} />
                        </div>
                        <Button close onClick={() => this.handleOnRemoveAssociation("Accountancy_MIA")} style={{padding: "7px 15px"}} title="Remove"></Button>
                    </FormGroup>
                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }} hidden={ this.state.AssociationLists.indexOf("Accountancy_MICPA") < 0 ? true : false } >
                        <Label for="Accountancy_MICPA_Input" sm={4}>(MICPA) Membership Number</Label >
                        <div className="col-sm-4" style={{ padding: "0 10px 0 0" }}>
                            <Input type="text" name="Accountancy_MICPA_Input" value={this.state["Accountancy_MICPA_Input"]} onChange={this.handleChange.bind(this)} />
                        </div>
                        <Button close onClick={() => this.handleOnRemoveAssociation("Accountancy_MICPA")} style={{padding: "7px 15px"}} title="Remove"></Button>
                    </FormGroup>
                </FormGroup>

                <FormGroup hidden={ this.state.ProfessionalCategory.indexOf("CompanySecretary") < 0 ? true : false } id="CompanySecretary_Form" style={{ backgroundColor: "lightgrey" }}>
                    <Label for="Company Secretary" className="col-sm-11 col-form-label"><b>Company Secretary</b></Label >
                    <Button close onClick={() => this.handleOnRemoveProfessionalCategory("CompanySecretary")} style={{padding: "7px 15px"}} title="Remove"></Button>
                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }}>
                        <Label for="RegulationBody" sm={4}>Regulator</Label >
                        <UncontrolledDropdown>
                            <DropdownToggle caret>{(this.state.CompanySecretary_Regulation !== undefined && this.state.CompanySecretary_Regulation.length > 0) ? this.state.CompanySecretary_Regulation[0].name : "Please Select" }</DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem onClick={() => this.handleOnRegulation("CompanySecretary", "Suruhanjaya Syarikat Malaysia (SSM)​")}>Suruhanjaya Syarikat Malaysia (SSM)​</DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </FormGroup>
                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }}>
                        <Label for="AssociationBody" sm={4}>Association/Institution</Label >
                        <UncontrolledDropdown>
                            <DropdownToggle caret>{ this.state.Selected_CompanySecretary_Association }</DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem onClick={() => this.handleOnAssociation("CompanySecretary", "Malaysia Institute of Chartered Secretaries and Administrators (MAICSA)")}>Malaysia Institute of Chartered Secretaries and Administrators (MAICSA)​</DropdownItem>
                                <DropdownItem onClick={() => this.handleOnAssociation("CompanySecretary", "Malaysia Institute of Accountants (MIA)")}>Malaysia Institute of Accountants (MIA)​</DropdownItem>
                                <DropdownItem onClick={() => this.handleOnAssociation("CompanySecretary", "Malaysia Institute of Certified Public Accounts (MICPA)")}>Malaysia Institute of Certified Public Accounts (MICPA)​</DropdownItem>
                                <DropdownItem onClick={() => this.handleOnAssociation("CompanySecretary", "Malaysia Bar (BC)")}>Malaysia Bar (BC)</DropdownItem>
                                <DropdownItem onClick={() => this.handleOnAssociation("CompanySecretary", "Malaysia Association of Company Secretaries (MACS)")}>Malaysia Association of Company Secretaries (MACS)</DropdownItem>
                                <DropdownItem onClick={() => this.handleOnAssociation("CompanySecretary", "Advocates Association of Sarawak (AAS)")}>Advocates Association of Sarawak (AAS)​</DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                        &nbsp;
                        <Button color="primary" onClick={() => this.handleOnAssociationInputField("CompanySecretary", "Selected_CompanySecretary_Association")} disabled={ this.state.Selected_CompanySecretary_Association === "Please Select" ? true : false }>Add New</Button>
                    </FormGroup>

                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }} hidden={ this.state.AssociationLists.indexOf("CompanySecretary_MAICSA") < 0 ? true : false } >
                        <Label for="CompanySecretary_MAICSA_Input" sm={4}>(MAICSA) Membership Number</Label >
                        <div className="col-sm-4" style={{ padding: "0 10px 0 0" }}>
                            <Input type="text" name="CompanySecretary_MAICSA_Input" value={this.state["CompanySecretary_MAICSA_Input"]} onChange={this.handleChange.bind(this)} />
                        </div>
                        <Button close onClick={() => this.handleOnRemoveAssociation("CompanySecretary_MAICSA")} style={{padding: "7px 15px"}} title="Remove"></Button>
                    </FormGroup>
                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }} hidden={ this.state.AssociationLists.indexOf("CompanySecretary_MIA") < 0 ? true : false } >
                        <Label for="CompanySecretary_MIA_Input" sm={4}>(MIA) Membership Number</Label >
                        <div className="col-sm-4" style={{ padding: "0 10px 0 0" }}>
                            <Input type="text" name="CompanySecretary_MIA_Input" value={this.state["CompanySecretary_MIA_Input"]} onChange={this.handleChange.bind(this)} />
                        </div>
                        <Button close onClick={() => this.handleOnRemoveAssociation("CompanySecretary_MIA")} style={{padding: "7px 15px"}} title="Remove"></Button>
                    </FormGroup>
                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }} hidden={ this.state.AssociationLists.indexOf("CompanySecretary_MICPA") < 0 ? true : false } >
                        <Label for="CompanySecretary_MICPA_Input" sm={4}>(MICPA) Membership Number</Label >
                        <div className="col-sm-4" style={{ padding: "0 10px 0 0" }}>
                            <Input type="text" name="CompanySecretary_MICPA_Input" value={this.state["CompanySecretary_MICPA_Input"]} onChange={this.handleChange.bind(this)} />
                        </div>
                        <Button close onClick={() => this.handleOnRemoveAssociation("CompanySecretary_MICPA")} style={{padding: "7px 15px"}} title="Remove"></Button>
                    </FormGroup>
                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }} hidden={ this.state.AssociationLists.indexOf("CompanySecretary_BC") < 0 ? true : false } >
                        <Label for="CompanySecretary_BC_Input" sm={4}>(BC) Membership Number</Label >
                        <div className="col-sm-4" style={{ padding: "0 10px 0 0" }}>
                            <Input type="text" name="CompanySecretary_BC_Input" value={this.state["CompanySecretary_BC_Input"]} onChange={this.handleChange.bind(this)} />
                        </div>
                        <Button close onClick={() => this.handleOnRemoveAssociation("CompanySecretary_BC")} style={{padding: "7px 15px"}} title="Remove"></Button>
                    </FormGroup>
                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }} hidden={ this.state.AssociationLists.indexOf("CompanySecretary_MACS") < 0 ? true : false } >
                        <Label for="CompanySecretary_MACS_Input" sm={4}>(MACS) Membership Number</Label >
                        <div className="col-sm-4" style={{ padding: "0 10px 0 0" }}>
                            <Input type="text" name="CompanySecretary_MACS_Input" value={this.state["CompanySecretary_MACS_Input"]} onChange={this.handleChange.bind(this)} />
                        </div>
                        <Button close onClick={() => this.handleOnRemoveAssociation("CompanySecretary_MACS")} style={{padding: "7px 15px"}} title="Remove"></Button>
                    </FormGroup>
                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }} hidden={ this.state.AssociationLists.indexOf("CompanySecretary_AAS") < 0 ? true : false } >
                        <Label for="CompanySecretary_AAS_Input" sm={4}>(AAS) Membership Number</Label >
                        <div className="col-sm-4" style={{ padding: "0 10px 0 0" }}>
                            <Input type="text" name="CompanySecretary_AAS_Input" value={this.state["CompanySecretary_AAS_Input"]} onChange={this.handleChange.bind(this)} />
                        </div>
                        <Button close onClick={() => this.handleOnRemoveAssociation("CompanySecretary_AAS")} style={{padding: "7px 15px"}} title="Remove"></Button>
                    </FormGroup>
                </FormGroup>

                <FormGroup hidden={ this.state.ProfessionalCategory.indexOf("TaxAgent") < 0 ? true : false } id="TaxAgent_Form" style={{ backgroundColor: "lightgrey" }}>
                    <Label for="Tax Agent" className="col-sm-11 col-form-label"><b>Tax Agent</b></Label >
                    <Button close onClick={() => this.handleOnRemoveProfessionalCategory("TaxAgent")} style={{padding: "7px 15px"}} title="Remove"></Button>
                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }}>
                        <Label for="RegulationBody" sm={4}>Regulator</Label >
                        <UncontrolledDropdown>
                            <DropdownToggle caret>{(this.state.TaxAgent_Regulation !== undefined && this.state.TaxAgent_Regulation.length > 0) ? this.state.TaxAgent_Regulation[0].name : "Please Select" }</DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem onClick={() => this.handleOnRegulation("TaxAgent", "Lembaga Hasil Dalam Negeri (LHDN)")}>Lembaga Hasil Dalam Negeri (LHDN)​</DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </FormGroup>
                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }}>
                        <Label for="AssociationBody" sm={4}>Association/Institution</Label >
                        <UncontrolledDropdown>
                            <DropdownToggle caret>{ this.state.Selected_TaxAgent_Association }</DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem onClick={() => this.handleOnAssociation("TaxAgent", "Chartered Tax Institute of Malaysia (CTiM)")}>Chartered Tax Institute of Malaysia (CTiM)​</DropdownItem>
                                <DropdownItem onClick={() => this.handleOnAssociation("TaxAgent", "Malaysia Institute of Accountants (MIA)​​")}>Malaysia Institute of Accountants (MIA)​​</DropdownItem>
                                <DropdownItem onClick={() => this.handleOnAssociation("TaxAgent", "Persatuan Akauntan Percukaian Malaysia (MATA)​")}>Persatuan Akauntan Percukaian Malaysia (MATA)​​​</DropdownItem>
                                <DropdownItem onClick={() => this.handleOnAssociation("TaxAgent", "Malaysia Institute of Chartered Secretaries and Administrators (MAICSA)​")}>Malaysia Institute of Chartered Secretaries and Administrators (MAICSA)​</DropdownItem>
                                <DropdownItem onClick={() => this.handleOnAssociation("TaxAgent", "Malaysia Association of Company Secretaries (MACS)​")}>Malaysia Association of Company Secretaries (MACS)​​​</DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                        &nbsp;
                        <Button color="primary" onClick={() => this.handleOnAssociationInputField("TaxAgent", "Selected_TaxAgent_Association")} disabled={ this.state.Selected_TaxAgent_Association === "Please Select" ? true : false }>Add New</Button>
                    </FormGroup>

                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }} hidden={ this.state.AssociationLists.indexOf("TaxAgent_CTiM") < 0 ? true : false } >
                        <Label for="TaxAgent_CTiM_Input" sm={4}>(CTiM) Membership Number</Label >
                        <div className="col-sm-4" style={{ padding: "0 10px 0 0" }}>
                            <Input type="text" name="TaxAgent_CTiM_Input" value={this.state["TaxAgent_CTiM_Input"]} onChange={this.handleChange.bind(this)} />
                        </div>
                        <Button close onClick={() => this.handleOnRemoveAssociation("TaxAgent_CTiM")} style={{padding: "7px 15px"}} title="Remove"></Button>
                    </FormGroup>
                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }} hidden={ this.state.AssociationLists.indexOf("TaxAgent_MIA") < 0 ? true : false } >
                        <Label for="TaxAgent_MIA_Input" sm={4}>(MIA) Membership Number</Label >
                        <div className="col-sm-4" style={{ padding: "0 10px 0 0" }}>
                            <Input type="text" name="TaxAgent_MIA_Input" value={this.state["TaxAgent_MIA_Input"]} onChange={this.handleChange.bind(this)} />
                        </div>
                        <Button close onClick={() => this.handleOnRemoveAssociation("TaxAgent_MIA")} style={{padding: "7px 15px"}} title="Remove"></Button>
                    </FormGroup>
                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }} hidden={ this.state.AssociationLists.indexOf("TaxAgent_MATA") < 0 ? true : false } >
                        <Label for="TaxAgent_MATA_Input" sm={4}>(MATA) Membership Number</Label >
                        <div className="col-sm-4" style={{ padding: "0 10px 0 0" }}>
                            <Input type="text" name="TaxAgent_MATA_Input" value={this.state["TaxAgent_MATA_Input"]} onChange={this.handleChange.bind(this)} />
                        </div>
                        <Button close onClick={() => this.handleOnRemoveAssociation("TaxAgent_MATA")} style={{padding: "7px 15px"}} title="Remove"></Button>
                    </FormGroup>
                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }} hidden={ this.state.AssociationLists.indexOf("TaxAgent_MAICSA") < 0 ? true : false } >
                        <Label for="TaxAgent_MAICSA_Input" sm={4}>(MAICSA) Membership Number</Label >
                        <div className="col-sm-4" style={{ padding: "0 10px 0 0" }}>
                            <Input type="text" name="TaxAgent_MAICSA_Input" value={this.state["TaxAgent_MAICSA_Input"]} onChange={this.handleChange.bind(this)} />
                        </div>
                        <Button close onClick={() => this.handleOnRemoveAssociation("TaxAgent_MAICSA")} style={{padding: "7px 15px"}} title="Remove"></Button>
                    </FormGroup>
                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }} hidden={ this.state.AssociationLists.indexOf("TaxAgent_MACS") < 0 ? true : false } >
                        <Label for="TaxAgent_MACS_Input" sm={4}>(MACS) Membership Number</Label >
                        <div className="col-sm-4" style={{ padding: "0 10px 0 0" }}>
                            <Input type="text" name="TaxAgent_MACS_Input" value={this.state["TaxAgent_MACS_Input"]} onChange={this.handleChange.bind(this)} />
                        </div>
                        <Button close onClick={() => this.handleOnRemoveAssociation("TaxAgent_MACS")} style={{padding: "7px 15px"}} title="Remove"></Button>
                    </FormGroup>
                </FormGroup>

                <FormGroup hidden={ this.state.ProfessionalCategory.indexOf("Contractor") < 0 ? true : false } id="Contractor_Form" style={{ backgroundColor: "lightgrey" }}>
                    <Label for="Contractor" className="col-sm-11 col-form-label"><b>Contractor</b></Label >
                    <Button close onClick={() => this.handleOnRemoveProfessionalCategory("Contractor")} style={{padding: "7px 15px"}} title="Remove"></Button>
                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }}>
                        <Label for="RegulationBody" sm={4}>Regulator</Label >
                        <UncontrolledDropdown>
                            <DropdownToggle caret>{(this.state.Contractor_Regulation !== undefined && this.state.Contractor_Regulation.length > 0) ? this.state.Contractor_Regulation[0].name : "Please Select" }</DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem onClick={() => this.handleOnRegulation("Contractor", "Construction Industry Development Board (CIDB)")}>Construction Industry Development Board (CIDB)</DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </FormGroup>
                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }} hidden={ this.state.AdditionalField.indexOf("Contractor_Grade") < 0 ? true : false} >
                        <Label for="Contractor_Choice_Input" sm={4}>Grade</Label >
                        <UncontrolledDropdown>
                            <DropdownToggle caret>{ (this.state.Contractor_Grade !== undefined) ? this.state.Contractor_Grade : "Please Select" }</DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem onClick={() => this.handleOnContractorGrade("Contractor", "G1")}>G1</DropdownItem>
                                <DropdownItem onClick={() => this.handleOnContractorGrade("Contractor", "G2")}>G2</DropdownItem>
                                <DropdownItem onClick={() => this.handleOnContractorGrade("Contractor", "G3")}>G3</DropdownItem>
                                <DropdownItem onClick={() => this.handleOnContractorGrade("Contractor", "G4")}>G4</DropdownItem>
                                <DropdownItem onClick={() => this.handleOnContractorGrade("Contractor", "G5")}>G5</DropdownItem>
                                <DropdownItem onClick={() => this.handleOnContractorGrade("Contractor", "G6")}>G6</DropdownItem>
                                <DropdownItem onClick={() => this.handleOnContractorGrade("Contractor", "G7")}>G7</DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </FormGroup>
                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }} hidden={ this.state.AdditionalField.indexOf("Contractor_RegistrationNo") < 0 ? true : false } >
                        <Label for="Contractor_RegistrationNo_Input" sm={4}>Registration Number</Label >
                        <div className="col-sm-4" style={{ padding: "0 10px 0 0" }}>
                            <Input type="text" name="Contractor_RegistrationNo_Input" value={this.state["Contractor_RegistrationNo_Input"]} onChange={this.handleChange.bind(this)} />
                        </div>
                    </FormGroup>
                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }}>
                        <Label for="AssociationBody" sm={4}>Association/Institution</Label >
                        <UncontrolledDropdown>
                            <DropdownToggle caret>{ this.state.Selected_Contractor_Association }</DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem onClick={() => this.handleOnAssociation("Contractor", "Master Builders Association Malaysia (MBAM)")}>Master Builders Association Malaysia (MBAM)​</DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                        &nbsp;
                        <Button color="primary" onClick={() => this.handleOnAssociationInputField("Contractor", "Selected_Contractor_Association")} disabled={ this.state.Selected_Contractor_Association === "Please Select" ? true : false }>Add New</Button>
                    </FormGroup>

                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }} hidden={ this.state.AssociationLists.indexOf("Contractor_MBAM") < 0 ? true : false } >
                        <Label for="Contractor_MBAM_Input" sm={4}>(MBAM) Membership Number</Label >
                        <div className="col-sm-4" style={{ padding: "0 10px 0 0" }}>
                            <Input type="text" name="Contractor_MBAM_Input" value={this.state["Contractor_MBAM_Input"]} onChange={this.handleChange.bind(this)} />
                        </div>
                        <Button close onClick={() => this.handleOnRemoveAssociation("Contractor_MBAM")} style={{padding: "7px 15px"}} title="Remove"></Button>
                    </FormGroup>
                </FormGroup>

                <FormGroup hidden={ this.state.ProfessionalCategory.indexOf("Others") < 0 ? true : false } id="Others_Form" style={{ backgroundColor: "lightgrey" }}>
                    <Label for="Others" className="col-sm-11 col-form-label"><b>Others</b></Label >
                    <Button close onClick={() => this.handleOnRemoveProfessionalCategory("Others")} style={{padding: "7px 15px"}} title="Remove"></Button>
                    
                    {/* <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }} hidden={ this.state.AdditionalField.indexOf("Others_RegistrationNo") < 0 ? true : false } > */}
                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }} >
                        <Label for="Others_Regulator_Input" sm={4}>Regulator</Label >
                        <div className="col-sm-4" style={{ padding: "0 10px 0 0" }}>
                            <Input type="text" name="Others_Regulator_Input" value={this.state["Others_Regulator_Input"]} onChange={this.handleChange.bind(this)} />
                        </div>
                    </FormGroup>
                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }} >
                        <Label for="Others_RegistrationNo_Input" sm={4}>Registration Number</Label >
                        <div className="col-sm-4" style={{ padding: "0 10px 0 0" }}>
                            <Input type="text" name="Others_RegistrationNo_Input" value={this.state["Others_RegistrationNo_Input"]} onChange={this.handleChange.bind(this)} />
                        </div>
                    </FormGroup>
                    {/* <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }} hidden={ this.state.AdditionalField.indexOf("Others_Association") < 0 ? true : false } > */}
                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }} >
                        <Label for="Others_Association_Input" sm={4}>Association/Institution</Label >
                        <div className="col-sm-4" style={{ padding: "0 10px 0 0" }}>
                            <Input type="text" name="Others_Association_Input" value={this.state["Others_Association_Input"]} onChange={this.handleChange.bind(this)} />
                        </div>
                    </FormGroup>
                    {/* <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }} hidden={ this.state.AdditionalField.indexOf("Others_MembershipNo") < 0 ? true : false } > */}
                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }}>
                        <Label for="Others_MembershipNo_Input" sm={4}>Membership Number</Label >
                        <div className="col-sm-4" style={{ padding: "0 10px 0 0" }}>
                            <Input type="text" name="Others_MembershipNo_Input" value={this.state["Others_MembershipNo_Input"]} onChange={this.handleChange.bind(this)} />
                        </div>
                    </FormGroup>
                </FormGroup>

                <FormGroup hidden={ this.state.ProfessionalCategory.indexOf("Engineering") < 0 ? true : false } id="Engineering_Form" style={{ backgroundColor: "lightgrey" }}>
                    <Label for="Engineering" className="col-sm-11 col-form-label"><b>Engineering</b></Label >
                    <Button close onClick={() => this.handleOnRemoveProfessionalCategory("Engineering")} style={{padding: "7px 15px"}} title="Remove"></Button>
                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }}>
                        <Label for="RegulationBody" sm={4}>Regulator</Label >
                        <UncontrolledDropdown>
                            <DropdownToggle caret>{(this.state.Engineering_Regulation !== undefined && this.state.Engineering_Regulation.length > 0) ? this.state.Engineering_Regulation[0].name : "Please Select" }</DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem onClick={() => this.handleOnRegulation("Engineering", "Board of Engineers, Malaysia (BEM)")}>Board of Engineers, Malaysia (BEM)</DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </FormGroup>
                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }} hidden={ this.state.AdditionalField.indexOf("Engineering_RegistrationNo") < 0 ? true : false } >
                        <Label for="Engineering_RegistrationNo_Input" sm={4}>License Number</Label >
                        <div className="col-sm-4" style={{ padding: "0 10px 0 0" }}>
                            <Input type="text" name="Engineering_RegistrationNo_Input" value={this.state["Engineering_RegistrationNo_Input"]} onChange={this.handleChange.bind(this)} />
                        </div>
                    </FormGroup>
                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }}>
                        <Label for="AssociationBody" sm={4}>Association/Institution</Label >
                        <UncontrolledDropdown>
                            <DropdownToggle caret>{ this.state.Selected_Engineering_Association }</DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem onClick={() => this.handleOnAssociation("Engineering", "The Institution of Engineers, Malaysia (IEM)​")}>The Institution of Engineers, Malaysia (IEM)​</DropdownItem>
                                <DropdownItem onClick={() => this.handleOnAssociation("Engineering", "Association of Consulting Engineers Malaysia (ACEM)​")}>Association of Consulting Engineers Malaysia (ACEM)​</DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                        &nbsp;
                        <Button color="primary" onClick={() => this.handleOnAssociationInputField("Engineering", "Selected_Engineering_Association")} disabled={ this.state.Selected_Engineering_Association === "Please Select" ? true : false }>Add New</Button>
                    </FormGroup>

                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }} hidden={ this.state.AssociationLists.indexOf("Engineering_IEM") < 0 ? true : false } >
                        <Label for="Engineering_IEM_Input" sm={4}>(IEM) Membership Number</Label >
                        <div className="col-sm-4" style={{ padding: "0 10px 0 0" }}>
                            <Input type="text" name="Engineering_IEM_Input" value={this.state["Engineering_IEM_Input"]} onChange={this.handleChange.bind(this)} />
                        </div>
                        <Button close onClick={() => this.handleOnRemoveAssociation("Engineering_IEM")} style={{padding: "7px 15px"}} title="Remove"></Button>
                    </FormGroup>
                    <FormGroup row style={{ padding: "calc(.375rem + 1px) 15px", margin: "0px -15px" }} hidden={ this.state.AssociationLists.indexOf("Engineering_ACEM") < 0 ? true : false } >
                        <Label for="Engineering_ACEM_Input" sm={4}>(ACEM) Membership Number</Label >
                        <div className="col-sm-4" style={{ padding: "0 10px 0 0" }}>
                            <Input type="text" name="Engineering_ACEM_Input" value={this.state["Engineering_ACEM_Input"]} onChange={this.handleChange.bind(this)} />
                        </div>
                        <Button close onClick={() => this.handleOnRemoveAssociation("Engineering_ACEM")} style={{padding: "7px 15px"}} title="Remove"></Button>
                    </FormGroup>
                </FormGroup>

                <div className="row">
                    <div className="col-12">
                        <Button color="primary" className=" float-right">Update Professional</Button>
                    </div>
                </div>
            </Form>

        );
    }
    renderCompany(){
        const positionOptions : any = [];
        var positionArray = this.state.positionList.split(',');
        for(var i = 0; i < positionArray.length; i++)
        {
            positionOptions.push({value: positionArray[i], label:positionArray[i]});
        }
        const salaryOptions = [
            { value: '1,500-3,000', label: '1,500-3,000' },
            { value: '3,001-5,000', label: '3,001-5,000' },
            { value: '5,001-8,000', label: '5,001-8,000' },
            { value: '8,001-12,000', label: '8,001-12,000' },
            { value: '12,001-20,000', label: '12,001-20,000' },
            { value: '25,001 and above', label: '25,001 and above' },
        ];
        return (
            <Form className="mt-3 mb-3" onSubmit={(event: React.MouseEvent<any, MouseEvent>) => this.UpdateCompanyInfoBtn(event)}>
                <FormGroup row={true}>
                    <Label for="CompanyName" sm={3}>Company Name</Label >
                    <Col sm={9}>
                        <Input type="text" name="CompanyName" id="CompanyName"
                            value={this.state.CompanyName}
                            onChange={this.handleChange.bind(this)}
                        />
                    </Col>
                </FormGroup>
                <FormGroup row={true}>
                    <Label for="CompanyRegisterNo" sm={3}>Company Registration No.</Label >
                    <Col sm={9}>
                        <Input type="text" name="CompanyRegisterNo" id="CompanyRegisterNo"
                            value={this.state.CompanyRegisterNo}
                            onChange={this.handleChange.bind(this)}
                        />
                    </Col>
                </FormGroup>
                <FormGroup row={true}>
                    <Label for="Position" sm={3}>Your Position</Label >
                    <Col sm={9}>
                        {/* <Input type="text" name="Position" id="Position"
                            value={this.state.Position}
                            onChange={this.handleChange.bind(this)}
                        /> */}
                        {/* <Input type="select" name="Position"
                            id="Position"
                            value={this.state.Position}
                            onChange={this.handleChange.bind(this)}
                        >
                            <option selected value="">Please Select</option>
                            <option value="Manager">Manager</option>
                            <option value="Supervisor">Supervisor</option>
                            <option value="Secretary">Secretary</option>
                            <option value="Developer">Developer</option>
                        </Input> */}
                        <CreatableSelect
                            isMulti
                            defaultValue={this.handleMultiSelectedOption(positionOptions, this.state.Position)}
                            isClearable={this.state.isClearable}
                            name="Position"
                            options={positionOptions}
                            onChange={this.handleSelectOnChange}
                        />
                        <span style={{fontSize:"small"}}>Select from the list or key in your title/position</span>
                    </Col>
                </FormGroup>
                <FormGroup row={true}>
                    <Label for="CompanyContactNumber" sm={3}>Company Contact Number</Label >
                    <Col sm={9}>
                        {/* <Input type="text" name="CompanyContactNumber" id="CompanyContactNumber"
                            value={this.state.CompanyContactNumber}
                            onChange={this.handleChange.bind(this)}
                        /> */}
                        <PhoneInput
                            country={'my'} 
                            placeholder="+60 12-123 4567"
                            enableSearch = {true}
                            onlyCountries={['my','sg','kh']}
                            masks={{my: '..-..........', sg: '..-..........', kh: '..-..........'}}
                            value={this.state.CompanyContactNumber} 
                            onChange={phone => this.setState({ CompanyContactNumber : phone })}
                        />
                    </Col>
                </FormGroup>
                <FormGroup row={true}>
                    <Label for="CompanyAddress" sm={3}>Company Address</Label >
                    <Col sm={9}>
                        <Input type="textarea" name="CompanyAddress" id="CompanyAddress"
                            value={this.state.CompanyAddress} rows={5} style={{width: "100%"}}
                            onChange={this.handleChange.bind(this)}
                        />
                    </Col>
                </FormGroup>
                <FormGroup row={true}>
                    <Label for="SalaryRange" sm={3}>Salary Range (RM)</Label >
                    <Col sm={9}>
                        {/* <Input type="select" name="SalaryRange"
                            id="SalaryRange"
                            value={this.state.SalaryRange}
                            onChange={this.handleChange.bind(this)}
                        >
                            <option selected value="">Please Select</option>
                            <option value="<1500">&lt;1500</option>
                            <option value="1500-3000">1500-3000</option>
                            <option value="3001-5000">3001-5000</option>
                            <option value="5001-8000">5001-8000</option>
                            <option value="8001-12000">8001-12000</option>
                            <option value="12001-20000">12001-20000</option>
                            <option value="25001 and above" >25001 and above</option>
                            <option value=">5000" >&gt;5000</option>
                        </Input> */}
                        <Select
                            className="basic-select"
                            classNamePrefix="select"
                            defaultValue={this.handleSelectedOption(salaryOptions, this.state.SalaryRange)}
                            isClearable={this.state.isClearable}
                            isSearchable={this.state.isSearchable}
                            name="SalaryRange"
                            options={salaryOptions}
                            onChange={this.handleSelectOnChange}
                        />
                    </Col>
                </FormGroup>
                <div className="row">
                    <div className="col-12">
                        <Button color="primary" className=" float-right"  >Update Company Info</Button>
                    </div>
                </div>
            </Form>

        );
    }
    render() {
        
        return (
            <Container>
                {/* <Alert color="success" isOpen={this.state.UpdateState === 1} toggle={this.onDismiss}>
                    Successfully saved!
                </Alert>
                <Alert color="danger" isOpen={this.state.UpdateState === 2} toggle={this.onDismiss}>
                    {this.props.user?.error??"Failed retriving document"}
                </Alert>    */}
                { JSON.stringify(this.props.userInfo) }
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '1' })}
                            onClick={() => { this.toggle('1'); }}
                        ><i className="fas fa-info-circle mr-1"></i>Personal
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '2' })}
                            onClick={() => { this.toggle('2'); }}
                        ><i className="fas fa-building mr-1"></i>Company
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '3' })}
                            onClick={() => { this.toggle('3'); }}
                        ><i className="fas fa-briefcase mr-1"></i>Professional
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '4' })}
                            onClick={() => { this.toggle('4'); }}
                        ><i className="fas fa-id-card mr-1"></i>Identity
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '5' })}
                            onClick={() => { this.toggle('5'); }}
                        ><i className="fas fa-user mr-1"></i>Face Recognition
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId="1">
                        <Row>
                            <Col sm="12">
                                {this.renderPersonal()}
                            </Col>
                        </Row>
                    </TabPane>
                    <TabPane tabId="2">
                        <Row>
                            <Col sm="12">
                                {this.renderCompany()}
                            </Col>
                        </Row>
                    </TabPane>
                    <TabPane tabId="3">
                        <Row>
                            <Col sm="12" >
                                {this.renderProfessional()}
                            </Col>
                        </Row>
                    </TabPane>
                    <TabPane tabId="4">
                        <Row>
                            <Col sm="12">
                                {this.renderVerification()}
                            </Col>
                        </Row>
                    </TabPane>
                    <TabPane tabId="5">
                        <Row>
                            <Col sm="12">
                                {this.renderIdentity()}
                            </Col>
                        </Row>
                    </TabPane>
                </TabContent>

                <FaceDirection image='./images/HeadCentre.png' 
                    index = {0} title="Look at middle" left = {"30%"} right = {""} top = {"45%"} bottom = {""} transform = "translate(-50%, -50%)"
                    disableStartButton={this.state.disableStartButton}
                    faceProcessSuccess={this.state.faceProcessSuccess}
                    instructionMessage={this.state.instructionMessage}
                    currentDirection={this.state.YawDirection.CurrentDirection}
                    />
                <FaceDirection image='./images/HeadYawRight.png' 
                    index = {1}  title="Yaw to right" left = {""} right = {"0%"} top = {"25%"} bottom = {""} transform = ""
                    disableStartButton={this.state.disableStartButton}
                    faceProcessSuccess={this.state.faceProcessSuccess}
                    instructionMessage={this.state.instructionMessage}
                    currentDirection={this.state.YawDirection.CurrentDirection}
                    /> 
                    
                <FaceDirection image='./images/HeadYawLeft.png' 
                    index = {2} title="Yaw to left" left = {"0%"} right = {""} top = {"25%"} bottom = {""} transform = ""
                    disableStartButton={this.state.disableStartButton}
                    faceProcessSuccess={this.state.faceProcessSuccess}
                    instructionMessage={this.state.instructionMessage}
                    currentDirection={this.state.YawDirection.CurrentDirection}
                    />
                    
                <FaceDirection image='./images/HeadPitchUp.png' 
                    index = {3} title="Head up" left = {"30%"} right = {""} top = {"30%"} bottom = {""} transform = "translate(-50%, -50%)"
                    disableStartButton={this.state.disableStartButton}
                    faceProcessSuccess={this.state.faceProcessSuccess}
                    instructionMessage={this.state.instructionMessage}
                    currentDirection={this.state.YawDirection.CurrentDirection}
                    />

                <FaceDirection image='./images/HeadPitchDown.png' 
                    index = {4} title="Head down" left = {"30%"} right = {""} top = {"52%"} bottom = {""}  transform = "translate(-50%, -50%)"
                    disableStartButton={this.state.disableStartButton}
                    faceProcessSuccess={this.state.faceProcessSuccess}
                    instructionMessage={this.state.instructionMessage}
                    currentDirection={this.state.YawDirection.CurrentDirection}
                    />

                <br/><br/><br/><br/><br/><br/>
            </Container>
        );
    }

}

const mapStateToProps = (state: ApplicationState) => ({
    //user: state.userReducer
    user: state.userInfo.byId[0]
})

const mapDispatchToProps = {
    UpdateUserProfile: UpdateUserProfileAction,
    verified: verifiedAction,
    fetchUserRequest: getUserAction
}

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Profile1)

class FaceDirection extends React.Component<any, any>{
    
    constructor(props: any) {
        super(props);
        this.state = {
        }
    }
    render() {
        return (
        <div style={{backgroundColor:"white", width:"250px", textAlign:"center", 
            position:"absolute", left:this.props.left, right:this.props.right, top:this.props.top,  transform:this.props.transform}} 
            hidden={!(this.props.currentDirection == this.props.index && this.props.disableStartButton)}>
            <Spinner type="grow" color="danger" />&nbsp;<h3>{this.props.title}</h3>
            <img src={this.props.image} width="100%"/><br/>
            {
                this.props.faceProcessSuccess ? (
                    <span style={{color:"green"}}>{this.props.instructionMessage}</span>
                ) : (
                    <span style={{color:"red"}}>{this.props.instructionMessage}</span>
                )
            }
        </div>
        )
    }
}

class Progressbar extends React.Component<any, any>{
    interval: any;

    constructor(props: any) {
        super(props);
        this.state = {
            progress: 0,
            speed: 1,
            color: "#ff0050"
        }
        this.frame = this.frame.bind(this);
        this.green = this.green.bind(this);
        this.red = this.red.bind(this);
    }
    componentDidMount() {
        console.clear();
    }

    frame() {
        if (this.state.progress < 100) {
            if (this.state.progress <= this.props.progress) {

                this.setState((prevState: any, props: any) => ({
                    progress: prevState.progress + this.state.speed,
                    color: "#" + this.red() + this.green() + "50"
                }));
                //console.log(this.state.color);
            }


        }
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }
    componentDidUpdate(prevProps: any) {
        //console.log(prevProps);
        //console.log(this.props);
        if (this.props.start === true && prevProps.start === false) {
            this.setState({
                progress: 0,
                speed: 2,
                color: "#ff0050"
            }, this.start);
        }
        else if (this.props.start === false && prevProps.start === true) {
            clearInterval(this.interval);
        }
    }
    start() {
        this.interval = setInterval(() => this.frame(), 100);

    }
    green() {
        let progress = this.state.progress;
        progress *= 2.55;
        progress = Math.round(progress);
        progress = progress.toString(16);
        return progress;
    }
    red() {
        let progress = this.state.progress;
        progress *= 2.55;
        progress = Math.round(progress);
        progress = 255 - progress;
        progress = progress.toString(16);
        return progress;
    }
    render() {
        return (
            this.state.progress == 100? (
                <div></div>
            ):(
            <div id="myBar" style={{
                width: this.state.progress + "%",
                backgroundColor: this.state.color
            }}>
                {
                    (this.state.progress > 5 &&
                        <div id="label">Processed {this.state.progress}%</div>
                    )
                }
            </div>)
        )
    }
}